import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Super admin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Responsabile vendite',
  [ManagerRole.SalesLeadership]: 'Direzione vendite',
  [ManagerRole.ContentManager]: 'Responsabile contenuti',
  [ManagerRole.OnboardingManager]: 'Responsabile onboarding',
  [ManagerRole.OccAgent]: 'Agente call center',
};
